"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if time is not future time with respect to a particular date.
 * @param message
 * @param fieldID
 * @returns {function({field: *})}
 */
var isDateTimeEqualToOrBefore = function isDateTimeEqualToOrBefore(message, fieldID) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    }

    var enteredDateStr = form.$(fieldID).value;
    var isValid = true;

    if (enteredDateStr) {
      var enteredDateTime = (0, _moment.default)("".concat(enteredDateStr, " ").concat(field.value), 'DD/MM/YYYY HH:mm');
      var now = (0, _moment.default)();
      isValid = enteredDateTime.isSameOrBefore(now);
    }

    return [isValid, message];
  };
};

var _default = isDateTimeEqualToOrBefore;
exports.default = _default;
//# sourceMappingURL=isDateTimeEqualToOrBefore.js.map